export const checkMark = ['0 0 32 32', `
<path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
`]
